import { Button, Modal } from "@/components/atoms";

export const DiscardModal = ({
  open,
  onClose,
  onConfirm,
  mode,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  mode: "add" | "edit";
}) => (
  <Modal
    open={open}
    onClose={onClose}
    variant="web-small"
    title={mode === "add" ? "Cancel Adding Vehicle Type?" : "Cancel Editing Vehicle Type?"}
    description="Your entered details will not be saved if you cancel now. Are you sure you want to discard this vehicle type?"
    renderButtons={() => (
      <>
        <Button variant="secondary" onClick={onClose} className="flex-1">
          Back
        </Button>
        <Button variant="primary" onClick={onConfirm} className="flex-1 bg-danger hover:bg-danger-dark">
          Cancel Anyway
        </Button>
      </>
    )}
  />
);
